<script lang="typescript">
  import Meeting from "./meeting/Meeting.svelte";
  import Add from './Add.svelte';
  import { createAddEvent, service } from '../addmachine';
  import { selectedDay } from '../store';
  const send = $service.send;
  const add = () => send(createAddEvent($selectedDay));
  $: state = $service.machine.current;
  $: day = $selectedDay;
  $: meetings = day.meetings;
  $: isAdding = ['editing', 'saving'].includes(state);
</script>

<div>
  <h2 class="selected-day">
    {day.weekday_long}
    {day.formatted}
  </h2>
  {#if meetings.length > 0}
    <ul>
      {#each meetings as meeting (meeting.id)}
        <Meeting {meeting} />
      {/each}
    </ul>
  {:else}
    <p>Päivälle ei ole sovittuja videotapaamisia.</p>
  {/if}
  {#if !isAdding}
  <button on:click={add}>Lisää tapaaminen</button>
  {:else}
    <Add />
  {/if}
</div>

<style>
</style>
